export class TokenExpiredError extends Error {
}
//# sourceMappingURL=TokenExpiredError.js.map